import { render } from "./Landing4.vue?vue&type=template&id=64a17ed0"
import script from "./Landing4.vue?vue&type=script&lang=js"
export * from "./Landing4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__